import React from 'react';
type ToothIconProps = {
  className?: string;
};
export function ToothIcon({
  className = 'h-5 w-5'
}: ToothIconProps) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true" data-id="element-359" data-mp="11hrqq8y9d6ib">
      <path d="M12 5.5c-1.6-1.4-3.4-2-5.2-1.6C4.6 4.4 3.5 6.6 3.8 9c.3 2.2 1.2 3.6 1.7 5.6.6 2.4.8 6.4 2.6 6.4 1.7 0 1.6-3.6 2.4-5.4.4-.9.9-1.3 1.5-1.3s1.1.4 1.5 1.3c.8 1.8.7 5.4 2.4 5.4 1.8 0 2-4 2.6-6.4.5-2 1.4-3.4 1.7-5.6.3-2.4-.8-4.6-3-5.1-1.8-.4-3.6.2-5.2 1.6Z" data-id="element-360" data-mp="rpm3fciybd9g" />
    </svg>;
}